import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const BaselineWorkOutlineIcon = (props: SVGProps) => {
  return <SpriteIcon spriteId="briefcase" {...props} />;
};

export { BaselineWorkOutlineIcon };
